/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportParamDto } from '../../models/report-param-dto';

export interface ReportsGetReportParams$Params {
  reportId?: number;
}

export function reportsGetReportParams(http: HttpClient, rootUrl: string, params?: ReportsGetReportParams$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportParamDto>> {
  const rb = new RequestBuilder(rootUrl, reportsGetReportParams.PATH, 'get');
  if (params) {
    rb.query('reportId', params.reportId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportParamDto>;
    })
  );
}

reportsGetReportParams.PATH = '/api/Reports/report/getReportParams';
